import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { _verifyMapExists, _createSite, _uploadSiteImage, _upadteSite, _getSiteDetails } from "../shared/httpservice/apis";
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
const initialState = {
    checkSite: createInitialState(),
    siteDetails: createInitialState(),
    createSite: createInitialState(),
    uploadSiteImage: createInitialState(),
    updateSite: createInitialState(),
    // buildings : createInitialState<any>()
};
export const checkMapExistsAction = createAsyncThunk("site/check ", async (id, { rejectWithValue }) => {
    try {
        const response = await _verifyMapExists(id);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getSiteDetailsAction = createAsyncThunk("site/checkV2 ", async (id, { rejectWithValue }) => {
    try {
        const response = await _getSiteDetails(id);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const createSiteAction = createAsyncThunk("site/createSite", async (data, { rejectWithValue }) => {
    try {
        const response = await _createSite(data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const uploadSiteImageAction = createAsyncThunk("site/uploadSiteImage", async ({ siteId, data }, { rejectWithValue }) => {
    try {
        const response = await _uploadSiteImage({ siteId, data });
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const updateSiteAction = createAsyncThunk("site/updateSite", async ({ siteId, data }, { rejectWithValue }) => {
    try {
        const response = await _upadteSite({ siteId, data });
        return response;
    }
    catch (error) {
        rejectWithValue(error);
    }
});
const siteSlice = createSlice({
    name: "site",
    initialState,
    reducers: {
        resetSiteSlice: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkMapExistsAction.pending, (state) => {
            state.checkSite.loading = true;
            state.checkSite.response = null;
            state.checkSite.hasError = false;
            state.checkSite.error = {};
        })
            .addCase(checkMapExistsAction.fulfilled, (state, action) => {
            state.checkSite.loading = false;
            state.checkSite.response = action.payload;
            state.checkSite.hasError = false;
            state.checkSite.error = {};
        })
            .addCase(checkMapExistsAction.rejected, (state, action) => {
            state.checkSite.loading = false;
            state.checkSite.response = null;
            state.checkSite.hasError = true;
            state.checkSite.error = action.payload;
        })
            .addCase(getSiteDetailsAction.pending, (state) => {
            state.checkSite.loading = true;
            state.checkSite.response = null;
            state.checkSite.hasError = false;
            state.checkSite.error = {};
        })
            .addCase(getSiteDetailsAction.fulfilled, (state, action) => {
            state.checkSite.loading = false;
            state.checkSite.response = action.payload;
            state.checkSite.hasError = false;
            state.checkSite.error = {};
        })
            .addCase(getSiteDetailsAction.rejected, (state, action) => {
            state.checkSite.loading = false;
            state.checkSite.response = null;
            state.checkSite.hasError = true;
            state.checkSite.error = action.payload;
        })
            .addCase(createSiteAction.pending, (state) => {
            state.createSite.loading = true;
            state.createSite.response = null;
            state.createSite.hasError = false;
            state.createSite.error = {};
        })
            .addCase(createSiteAction.fulfilled, (state, action) => {
            state.createSite.loading = false;
            state.createSite.response = action.payload;
            state.createSite.hasError = false;
            state.createSite.error = {};
        })
            .addCase(createSiteAction.rejected, (state, action) => {
            state.createSite.loading = false;
            state.createSite.response = null;
            state.createSite.hasError = true;
            state.createSite.error = action.payload;
        })
            .addCase(uploadSiteImageAction.pending, (state) => {
            state.uploadSiteImage.loading = true;
            state.uploadSiteImage.response = null;
            state.uploadSiteImage.hasError = false;
            state.uploadSiteImage.error = {};
        })
            .addCase(uploadSiteImageAction.fulfilled, (state, action) => {
            state.uploadSiteImage.loading = false;
            state.uploadSiteImage.response = action.payload;
            state.uploadSiteImage.hasError = false;
            state.uploadSiteImage.error = {};
        })
            .addCase(uploadSiteImageAction.rejected, (state, action) => {
            state.uploadSiteImage.loading = false;
            state.uploadSiteImage.response = null;
            state.uploadSiteImage.hasError = true;
            state.uploadSiteImage.error = action.payload;
        })
            .addCase(updateSiteAction.pending, (state) => {
            state.updateSite.loading = true;
            state.updateSite.response = null;
            state.updateSite.hasError = false;
            state.updateSite.error = {};
        })
            .addCase(updateSiteAction.fulfilled, (state, action) => {
            state.updateSite.loading = false;
            state.updateSite.response = action.payload;
            state.updateSite.hasError = false;
            state.updateSite.error = {};
        })
            .addCase(updateSiteAction.rejected, (state, action) => {
            state.updateSite.loading = false;
            state.updateSite.response = null;
            state.updateSite.hasError = true;
            state.updateSite.error = action.payload;
        });
    },
});
export const { resetSiteSlice } = siteSlice.actions;
export default siteSlice.reducer;
